import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import {Resource} from 'Event/template/NiftyFifty/Dashboard/Resources/ResourceList'
import ResourceItemConfig from 'Event/template/NiftyFifty/Dashboard/Resources/ResourceList/ResourceItemConfig'
import React, {useState} from 'react'

export default function AddResourceButton(props: {className?: string}) {
  const [resource, setResource] = useState<Resource | null>(null)

  const addResource = () => {
    const resource: Resource = {
      name: 'Resource',
      filePath: '',
      description: '',
      isVisible: true,
      rules: [],
      isUrl: false,
      linkText: 'Download',
      actionId: null,
      infusionsoftTag: null,
      mailchimpTag: null,
      zapierTag: null,
      highLevelTag: null,
      hubspotTag: null,
      hubspotV2Tag: null,
      activeCampaignTag: null,
      convertKitTag: null,
      ontraportTag: null,
      clickFunnelsTag: null,
    }

    setResource(resource)
  }

  return (
    <Container>
      <NewResourceConfig
        resource={resource}
        onClose={() => setResource(null)}
      />
      <Button
        fullWidth
        size="large"
        variant="contained"
        color="primary"
        aria-label="add resource"
        onClick={addResource}
        className={props.className}
      >
        Add Resource
      </Button>
    </Container>
  )
}

function NewResourceConfig(props: {
  resource: Resource | null
  onClose: () => void
}) {
  const {resource, onClose} = props
  if (!resource) {
    return null
  }

  return <ResourceItemConfig onClose={onClose} resource={resource} showing />
}

const Container = styled.div`
  padding: ${(props) => props.theme.spacing[6]}!important;
`
